import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDialog
} from "@angular/material";
import { PlacementReservationEntryComponent } from "../placement-reservation-entry/placement-reservation-entry.component";
import { StudentService } from "src/app/services/http/business/student/student.service";
import { PlacementDetailComponent } from "../placement-detail/placement-detail.component";
import { PlacementReportComponent } from "src/app/pages/placement-reservation/placement-report/placement-report.component";
import { AccountService } from "src/app/services/http/business/account/account.service";


@Component({
  selector: 'app-placement-reservations',
  templateUrl: './placement-reservations.component.html',
  styleUrls: ['./placement-reservations.component.css']
})
export class PlacementReservationsComponent implements OnInit {
  isPlacment: boolean = false;
  filter: any;
  dataSource = new MatTableDataSource();

  displayedColumns: string[] = [
    "placementType",
    "placementDate",
    "reservedTime",
    "price",
    "status",
    "branch",
    "teacherName",
    "courseLevel",
    "function"
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    public translate: TranslateService,
    private accountService: AccountService,
    private studentService: StudentService
  ) { }


  ngOnInit() {
    this.refresh();
  }

  refresh() {
    this.studentService.getPlacementsStatus().subscribe(res => {
      this.dataSource = null;
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  paginatorEvent(event) {
    this.studentService.getPlacementsStatus(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }


  placementReport(e) {
    this.accountService.getUserInfo().subscribe(res => {
      e.FullName = res.FullName;
      e.NationalCode = res.NationalCode;
      this.dialog
        .open(PlacementReportComponent, {
          data: e
        });
    });

  }

  getColor(statusId) {
    switch (statusId) {
      case 100:
        return "custom-chips accent";
      case 101:
        return "custom-chips warn";
      case 102:
        return "custom-chips success";
      case 103:
        return "custom-chips default";
      case 105:
        return "custom-chips primary";
      case 104:
        return "custom-chips accent";
      case 125:
        return "custom-chips primary";
      case 127:
        return "custom-chips accent";
      case 129:
        return "custom-chips accent";
      case 130:
        return "custom-chips accent";
      default:
        return "custom-chips default";
    }
  }

  add() {
    this.dialog
      .open(PlacementReservationEntryComponent, {
        width: '750px'

      })
      .afterClosed()
      .subscribe(() => {
        this.paginatorEvent(this.paginator);
      });
  }

  // show detials placement Reservation
  details(e) {
    console.log(e);
    this.dialog
      .open(PlacementDetailComponent, {
        data: e,
        width: '400px'
      });
  }
}
